import { Box, Typography } from "@mui/material";
import type { ReactNode } from "react";

interface ProfileSectionProps {
  title: string;
  subtitle?: string;
  id?: string;
  children: ReactNode;
}

/** Bloco de seção do perfil — visual alinhado ao dashboard mobile. */
export function ProfileSection({
  title,
  subtitle,
  id,
  children,
}: ProfileSectionProps) {
  return (
    <Box
      id={id}
      sx={{
        width: "100%",
        borderRadius: { xs: 2.5, md: 2 },
        border: "1px solid",
        borderColor: "divider",
        bgcolor: "background.paper",
        boxShadow: {
          xs: "0 2px 12px rgba(15, 23, 42, 0.04)",
          md: "none",
        },
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          px: { xs: 1.5, sm: 2.5, md: 3 },
          pt: { xs: 1.5, sm: 2 },
          pb: subtitle ? 0.75 : { xs: 0.5, sm: 1 },
        }}
      >
        <Typography
          variant="subtitle1"
          fontWeight={700}
          sx={{
            fontSize: { xs: "0.9375rem", sm: "1.0625rem" },
            color: "text.primary",
          }}
        >
          {title}
        </Typography>
        {subtitle ? (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mt: 0.35, fontSize: { xs: "0.8125rem", sm: "0.875rem" } }}
          >
            {subtitle}
          </Typography>
        ) : null}
      </Box>
      {children}
    </Box>
  );
}

/** Divisor interno das linhas do perfil — respeita padding lateral mobile. */
export function ProfileSectionDivider() {
  return <Box component="hr" sx={{ m: 0, border: "none", borderTop: "1px solid", borderColor: "divider", mx: { xs: 1.5, sm: 2.5, md: 3 } }} />;
}
